import { TableBody, TableItem, Text } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';
import { Pressable } from 'react-native';
import { useRecoilValue } from 'recoil';

import { homeGlobalState } from '../../../../../../store/home/capture/atom';
import { columnWidthsPendingRedemption } from '../../constants';

import { PendingRedemptionItemTypes } from '.';

export const PendingRedemptionItemDesktop: React.FC<PendingRedemptionItemTypes> = ({ item }) => {
  const { valueVisibility } = useRecoilValue(homeGlobalState);

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }
    return text;
  };

  return (
    <TableBody testId="table-body">
      <TableItem
        align="center"
        width={columnWidthsPendingRedemption.date}
        testId="header-settlement-date">
        <Text color={'neutral.darkest'} variant="semibold">
          {item.relatedDateNormalized}
        </Text>
      </TableItem>
      <TableItem width={columnWidthsPendingRedemption.client} testId="header-settlement-client">
        <Pressable onPress={() => {}}>
          <Text color={'neutral.darkest'} variant="regular">
            {item.customerNameNormalized}
          </Text>
        </Pressable>
      </TableItem>
      <TableItem width={columnWidthsPendingRedemption.product} testId="header-settlement-client">
        <Text variant="regular">{item.productDescriptionNormalized}</Text>
        <Text color={'neutral.medium'} fontSize={Typography['fontsize.xs']} variant="regular">
          {truncateText(item.productNameNormalized, 30)}
        </Text>
      </TableItem>
      <TableItem
        align="center"
        width={columnWidthsPendingRedemption.balance}
        testId="header-balance-estimation">
        <Text
          color={valueVisibility ? 'neutral.black' : 'neutral.darkest'}
          fontSize={valueVisibility ? Typography['fontsize.md'] : Typography['fontsize.xxs']}
          variant="semibold"
          letterSpacing={valueVisibility ? undefined : Typography['bullet.spacing']}>
          {valueVisibility
            ? Utils.Mask.Money(item.customerBalanceNormalized)
            : Typography['bullet.sequence']}
        </Text>
      </TableItem>
      <TableItem align="center" width={columnWidthsPendingRedemption.value} testId="header-value">
        <Text
          color={valueVisibility ? 'neutral.black' : 'neutral.darkest'}
          fontSize={valueVisibility ? Typography['fontsize.md'] : Typography['fontsize.xxs']}
          letterSpacing={valueVisibility ? undefined : Typography['bullet.spacing']}>
          {valueVisibility
            ? Utils.Mask.Money(item.operationValueNormalized)
            : Typography['bullet.sequence']}
        </Text>
      </TableItem>
    </TableBody>
  );
};
